export default __webpack_public_path__ + "static/media/v3.5d738658.jpg";